import { MakeCall } from '../createMakeCall';

const deleteUnitType = (makeCall: MakeCall) => (unitTypeId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/unit-type/${unitTypeId}`);

export { deleteUnitType };
